/**
 * @deprecated Use directly preventDefault, stopPropagation or stopImmediatePropagation instead
 * @param ev - Event
 */
export const stopEvent = (ev?: {
    preventDefault: () => void;
    stopPropagation: () => void;
    stopImmediatePropagation?: () => void;
}): false => {
    if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (ev.stopImmediatePropagation) {
            ev.stopImmediatePropagation();
        }
    }
    return false;
};
